import React from 'react';

const Cmp = React.lazy(()=>import('./FlatPickr.tsx'));

export default function LazyFlatPicker(props){
    return <React.Suspense fallback={null}>
        <Cmp {...props} />
    </React.Suspense>
}



